import { useMemo } from "react";
import { useSeo } from "@/hooks/useSeo";
import { faqs } from "@/mocks/faqs";
import { groups } from "@/mocks/groups";
import { site } from "@/mocks/site";
import Hero from "@/pages/home/components/Hero";
import StatsBand from "@/pages/home/components/StatsBand";
import FeaturedGroups from "@/pages/home/components/FeaturedGroups";
import CategoryGrid from "@/pages/home/components/CategoryGrid";
import RankingPreview from "@/pages/home/components/RankingPreview";
import GuideSteps from "@/pages/home/components/GuideSteps";
import Testimonials from "@/pages/home/components/Testimonials";
import FaqPreview from "@/pages/home/components/FaqPreview";
import CtaBanner from "@/pages/home/components/CtaBanner";

export default function Home() {
  const jsonLd = useMemo(() => {
    const origin = typeof window !== "undefined" ? window.location.origin : "";
    return [
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: site.name,
        description: site.description,
        email: site.email,
        url: `${origin}/`,
      },
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: site.name,
        alternateName: "51吃瓜群推荐与排行",
        inLanguage: "zh-CN",
        description: site.description,
      },
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqs.slice(0, 5).map((item) => ({
          "@type": "Question",
          name: item.question,
          acceptedAnswer: { "@type": "Answer", text: item.answer },
        })),
      },
      {
        "@context": "https://schema.org",
        "@type": "ItemList",
        name: "51吃瓜群本周推荐",
        itemListElement: groups
          .filter((item) => item.featured)
          .map((item, index) => ({
            "@type": "ListItem",
            position: index + 1,
            name: item.name,
            description: item.summary,
          })),
      },
    ];
  }, []);

  useSeo({
    title: "51吃瓜群推荐 - 靠谱活跃吃瓜群排行与选群指南",
    description:
      "吃瓜群精选为你推荐靠谱活跃的51吃瓜群，附群组排行与选群建议，从活跃度、管理规范和真实口碑三条标准出发，帮你快速找到高质量吃瓜群，避开冷清无效群。",
    keywords: "51吃瓜群,51吃瓜群推荐,51吃瓜群排行,吃瓜群哪个好,吃瓜群推荐",
    path: "/",
    jsonLd,
  });

  return (
    <>
      <Hero />
      <StatsBand />
      <FeaturedGroups />
      <CategoryGrid />
      <RankingPreview />
      <GuideSteps />
      <Testimonials />
      <FaqPreview />
      <CtaBanner />
    </>
  );
}